import { render, staticRenderFns } from "./ProjectTemplatesTable.vue?vue&type=template&id=51991c84&"
import script from "./ProjectTemplatesTable.vue?vue&type=script&lang=js&"
export * from "./ProjectTemplatesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports